import { render, staticRenderFns } from "./CustomerQrcodeTemplate.vue?vue&type=template&id=1ca53f0c&"
import script from "./CustomerQrcodeTemplate.vue?vue&type=script&lang=ts&"
export * from "./CustomerQrcodeTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports